<template>
    <div>
        <div class="dealer_contact_info gray-bg">
            <h6>
                <i class="fa fa-user" aria-hidden="true"></i>
                Asesor
            </h6>
            <a href="#">{{ `${asesorData.meta_keys.nombre} ${asesorData.meta_keys.apellido}` }}</a>
        </div>
        <div class="dealer_contact_info gray-bg">
            <h6>
                <i class="fa fa-envelope" aria-hidden="true"></i>
                Correo
            </h6>
            <a href="mailto:contact@example.com">{{ asesorData.email }}</a>
        </div>
        <div class="dealer_contact_info gray-bg">
            <h6>
                <i class="fa fa-phone" aria-hidden="true"></i>
                Celular
            </h6>
            <a href="tel:">{{ asesorData.meta_keys.celular }}</a>
        </div>
        <div class="dealer_contact_info gray-bg">
            <h6>
                <i class="fa fa-comment" aria-hidden="true"></i>
                Deja un Comentario
            </h6>
            <div class="form-group">
                <textarea
                    rows="2"
                    class="form-control"
                    placeholder=""
                    v-model="comentario"
                ></textarea>
            </div>
        </div>
        <div class="form-group text-center">
            <b-button
            :disabled="onLoadForm"
            @click="sendComentario">
            <clip-loader
            :class="{ 'd-none': !onLoadForm }"
            style="display: inline;margin-right: 10px;"  
            color="#fff" 
            size="15px"></clip-loader>
                Enviar Comentario
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            comentario: null,
            onLoadForm: false
        }
    },
    computed: {
        asesorData() {
            return this.$store.state.fichaTecnica.vehiculo.asesor 
        },
        propuestaID() {
            return this.$store.state.propuesta._id 
        }
    },
    methods: {
        sendComentario() {
            this.onLoadForm = true;
            var data = {
                comentario: this.comentario,
                id_propuesta: this.propuestaID
            }
            axios.post('/ajax/comentario_propuesta', data).then((res) => {
                this.onLoadForm = false;
                this.comentario = null;
            })
        }
    },
};
</script>

<style lang="scss" scoped></style>
